/**
 * XT-903 — may a CRM contact or company connect an AI assistant (MCP) to
 * Eleggia through the agent portal? The rule itself, pure, in one place: the
 * server applies it to the row it reads (`crmSubjectAiAccess`, apps/crm) and
 * the CRM detail view to the contact it shows, so the two cannot drift.
 *
 * Every email in the DMC's CRM connects — every contact and every company,
 * with no one ticking anything and no wait (owner, 2026-10-16, superseding the
 * 2026-10-14 exceptions: a portal sign-up and a shared demo login no longer
 * wait for "AI Access", and a supplier or a portal-made agency login is no
 * longer refused). What is held back:
 *
 *   - `not_registered` — no live row in this organisation's CRM;
 *   - `blocked` — a consultant ticked "Block AI assistant".
 *
 * A shared demo login still plans only as a rehearsal (`mcpSharedLogin`): that
 * decides how its work is filed, not whether it connects.
 */
export type AiAccessVerdict = 'allowed' | 'not_registered' | 'blocked';

/** Why a login may not connect. */
export type McpAccessDenial = Exclude<AiAccessVerdict, 'allowed'>;

/** What the rule reads of a live CRM row: only the block. */
export type AiAccessFacts = {
  readonly kind: 'contact' | 'company';
  readonly aiBlocked: boolean;
};

/** The verdict for a row, or for no row (`null`). */
export const aiAccessVerdict = (
  facts: AiAccessFacts | null
): AiAccessVerdict => {
  if (!facts) return 'not_registered';
  return facts.aiBlocked ? 'blocked' : 'allowed';
};
